import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Button } from '@/components/ui/button';
import { useToast } from '@/hooks/use-toast';

export default function TestLogoUpload() {
  const [uploading, setUploading] = useState(false);
  const { toast } = useToast();

  const uploadLogo = async () => {
    setUploading(true);
    try {
      const sourceUrl = `${window.location.origin}/show-up-logo-for-upload.png`;
      const { data, error } = await supabase.functions.invoke('upload-logo', {
        body: { sourceUrl, filename: 'show-up-logo-email-v2.png' }
      });
      
      if (error) {
        throw error;
      }

      console.log('Upload result:', data);
      toast({
        title: "Logo uploaded successfully!",
        description: `Public URL: ${data.publicUrl}`,
      });
    } catch (error: any) {
      console.error('Upload error:', error);
      toast({
        title: "Upload failed",
        description: error.message,
        variant: "destructive",
      });
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="container mx-auto p-8">
      <h1 className="text-2xl font-bold mb-4">Test Logo Upload</h1>
      <Button onClick={uploadLogo} disabled={uploading}>
        {uploading ? 'Uploading...' : 'Upload Logo to Storage'}
      </Button>
    </div>
  );
}